// extracted by mini-css-extract-plugin
module.exports = {"RedisDashboard":"RedisDashboard_3EQTV"};